import * as React from 'react';
import spreadsheetsApiClient from '../lib/spreadsheetsApiClient';
import { EntityContext } from './EntityProvider';
const ExerciseLoader = _ref => {
  let {
    children,
    environment,
    exerciseId
  } = _ref;
  const entityContext = React.useContext(EntityContext);
  const exercise = entityContext.getExercise(exerciseId);

  // load exercise when id changes
  React.useEffect(() => {
    if (exercise === undefined) {
      spreadsheetsApiClient(environment).getExercise(exerciseId).then(ex => {
        entityContext.setExercise(exerciseId, ex);
      });
    }
  }, [entityContext, environment, exercise, exerciseId]);
  return React.useMemo(() => children({
    exercise
  }), [children, exercise]);
};
export default ExerciseLoader;